import { CrudStoreItem } from 'legacy/lut/classes/models/CrudStoreItem'
import { IFormPartners } from 'legacy/lut/classes/models/IFormPartners'
import { IFormProfile } from 'legacy/lut/classes/models/IFormProfile'

import { IForm } from 'core-components/classes/models/IForm'
import { CrudStore } from 'core/types/crudStore'

const PartnerExtFields = {
  EntryIdExt: 'EntryId',
  Modified: 'Modified',
  ModifiedBy: 'ModifiedBy',
  Created: 'Created',
  CreatedBy: 'CreatedBy',
  AddressLine1Ext: 'AddressLine1',
  AddressLine2Ext: 'AddressLine2',
  AddressLine3Ext: 'AddressLine3',
  CityExt: 'City',
  CommunicationNameExt: 'CommunicationName',
  CountryExt: 'Country',
  EmailExt: 'Email',
  LocationIDExt: 'LocationID',
  StateExt: 'State',
  TaxIDExt: 'TaxID',
  URLExt: 'URL',
  ZIPCodeExt: 'ZIPCode',
  MainPhoneExt: 'MainPhone',
  MainPhoneCountryCodeExt: 'MainPhoneCountryCode',
  ModifiedValues: 'ModifiedValues',
  ProfileTeamComment: 'ProfileTeamComment',
  WorkflowStatus: 'WorkflowStatus',
  Hierarchy: 'Hierarchy',
  TopPartnerIDExt: 'TopPartnerID',
  StoreNumberExt: 'StoreNumber',
}

const AddExtFields = {
  EntryIdAdd: 'EntryId',
  SocialMediaUrls: 'SocialMediaUrls',
  ECommerceUrls: 'ECommerceUrls',
  ECommerceWeDontSellOnline: 'ECommerceWeDontSellOnline',
  FacebookLink: 'FacebookLink',
  LinkedInLink: 'LinkedInLink',
  TwitterLink: 'TwitterLink',
  WhatsAppLink: 'WhatsAppLink',
  CompanyDomains: 'CompanyDomains',
  AltVendorPc: 'AltVendorPc',
  AltVendorPrint: 'AltVendorPrint',
  Stocking: 'Stocking',
  eCommerce: 'eCommerce',
  TagIdList: 'TagIdList',
  eCommerceDetails: 'eCommerceDetails',
  PartnerSince: 'PartnerSince',
  ResponseTimeUnits: 'ResponseTimeUnits',
  ResponseTimeNumber: 'ResponseTimeNumber',
  Hours: 'Hours',
  Image: 'Image',
  Gallery: 'Gallery',
  Description: 'Description',
  LoyaltyIndex: 'LoyaltyIndex',
  Link: 'Link',
  ServiceCoverage: 'ServiceCoverage',
  PostalCodes: 'PostalCodes',
  Lng: 'Lng',
  Lat: 'Lat',
  MainContact: 'MainContact',
  BackupContacts: 'BackupContacts',
  NeedUpdateInMetalocator: 'NeedUpdateInMetalocator',
  CoverageNumber: 'CoverageNumber',
  CoverageUnit: 'CoverageUnit',
  ZipCodes: 'ZipCodes',
  ZipCodeCovered: 'ZipCodeCovered',
  PartnerAgrees: 'PartnerAgrees',
  PartnerCommunication: 'PartnerCommunication',
  ModifiedAdd: 'ModifiedAdd',
  ModifiedByAdd: 'ModifiedByAdd',
  Completement: 'Completement',
  CompanyLegalNameNonLatin: 'CompanyLegalNameNonLatin',
}

const LegalExtFields = {
  CompanyLegalNameExt: 'CompanyLegalName',
  LegalAddr1Ext: 'LegalAddr1',
  LegalAddr2Ext: 'LegalAddr2',
  LegalAddr3Ext: 'LegalAddr3',
  LegalCityExt: 'LegalCity',
  LegalCountryExt: 'LegalCountry',
  LegalStateExt: 'LegalState',
  LegalPostalCodeExt: 'LegalPostalCode',
  LegalApproverCommentExt: 'LegalApproverComment',
  LegalProfilingComment: 'LegalProfilingComment',
  LegalWorkflowStatusExt: 'LegalWorkflowStatus',
  LegalModifiedValuesExt: 'LegalModifiedValues',
  LegalModifiedExt: 'Modified',
  LegalEntryIdExt: 'EntryId',
  LegalAttachment: 'Attachment',
  CompanyLegalNameNonLatinExt: 'CompanyLegalNameNonLatinExt',
}

const ContactExtFields = {
  EntryIdExt: 'EntryId',
  CountryOfBusinessExt: 'CountryOfBusiness',
  ContactIDExt: 'ContactID',
  EmailExt: 'Email',
  FirstNameExt: 'FirstName',
  LastNameExt: 'LastName',
  MobilePhoneExt: 'MobilePhone',
  MobilePhone_PrefixExt: 'MobilePhone_Prefix',
  NeverCallExt: 'NeverCallExt',
  NeverEmailExt: 'NeverEmail',
  NewPartnerIDExt: 'NewPartnerID',
  PartnerIDExt: 'PartnerID',
  PR_HP_ROLEExt: 'PR_HP_ROLE',
  PreferredLanguageExt: 'PreferredLanguage',
  SalutationExt: 'Salutation',
  SeniorityExt: 'Seniority',
  StatusExt: 'Status',
  WorkPhoneExt: 'WorkPhone',
  WorkPhone_PrefixExt: 'WorkPhone_Prefix',
  ModifiedValues: 'ModifiedValues',
  ProfileTeamComment: 'ProfileTeamComment',
  WorkflowStatus: 'WorkflowStatus',
  PrimaryJobRoleExt: 'PrimaryJobRole',
  RelinkingCommentIDExt: 'RelinkingComment',
  PrimaryPartner: 'PrimaryPartner',
}

const AddContactExtFields = {
  EntryIdAdd: 'EntryId',
  ChangeMindset: 'ChangeMindset',
  Competitors: 'Competitors',
  ContactStatus: 'ContactStatus',
  FacebookLink: 'FacebookLink',
  GDPR: 'GDPR',
  HPChampion: 'HPChampion',
  HPHero: 'HPHero',
  LinkedInLink: 'LinkedInLink',
  Photo: 'Photo',
  PreferredContact: 'PreferredContact',
  RelationshipStrength: 'RelationshipStrength',
  Role: 'Role',
  TwitterLink: 'TwitterLink',
  WhatsAppLink: 'WhatsAppLink',
  Modified: 'Modified',
  ModifiedBy: 'ModifiedBy',
  CreatedBy: 'CreatedBy',
}

const mergeUpdate = async (
  resultArr: IForm[],
  item: IForm,
  extFields: IObjectAny,
  crudStoreItem: CrudStoreItem,
  mainField: string
) => {
  const crud = CrudStore.get(crudStoreItem)
  if (mainField && item[mainField]) {
    const oldItem = await crud.getById({ id: item[mainField], keyField: mainField })
    if (oldItem) {
      for (const field in extFields) {
        const fieldExt = extFields[field]
        oldItem[field] = item[fieldExt]
      }
      resultArr.push(oldItem)
    }
  }
}

const mergeLegalAndOpened = (
  item: IForm,
  legalItem: IForm | undefined,
  openedItem: IForm | undefined,
  extFields: IObjectAny
) => {
  if (legalItem) {
    for (const field in extFields) {
      const fieldExt = extFields[field]
      legalItem[field] = item[fieldExt]
    }
  }

  if (openedItem) {
    for (const field in extFields) {
      const fieldExt = extFields[field]
      openedItem[field] = item[fieldExt]
    }
  }
}

export class CrudConnectors {
  public static updatePartnerAllData = async (
    formId: string,
    items: IFormPartners[]
  ): Promise<IFormPartners[]> => {
    const resultArr: IFormPartners[] = []
    if (!items[0]) {
      return resultArr
    }
    const item = items[0]
    const crudLegal = CrudStore.get(CrudStoreItem.LegalPartnerRequests)
    const crudOpened = CrudStore.get(CrudStoreItem.OpenedPartnerRequests)

    if (!item.PartnerID) {
      return resultArr
    }

    const legalItem = crudLegal.getDataFromStore().find((el) => el.PartnerID === item.PartnerID)
    const openedItem = crudOpened.getDataFromStore().find((el) => el.PartnerID === item.PartnerID)

    switch (formId) {
      case `406`:
        await mergeUpdate(
          resultArr,
          item,
          PartnerExtFields,
          CrudStoreItem.PartnerAllData,
          'PartnerID'
        )
        mergeLegalAndOpened(item, legalItem, openedItem, PartnerExtFields)
        return resultArr
      case `458`:
        await mergeUpdate(resultArr, item, AddExtFields, CrudStoreItem.PartnerAllData, 'PartnerID')
        mergeLegalAndOpened(item, legalItem, openedItem, AddExtFields)
        return resultArr
      case `502`:
        await mergeUpdate(
          resultArr,
          item,
          LegalExtFields,
          CrudStoreItem.PartnerAllData,
          'PartnerID'
        )
        mergeLegalAndOpened(item, legalItem, openedItem, LegalExtFields)
        return resultArr
    }
    return resultArr
  }

  public static deletePartnerAllData = async (
    formId: string,
    item: IForm
  ): Promise<IFormPartners[] | null> => {
    let resultItem: IFormPartners | null = null
    let oldItem: IFormPartners | null = null
    const crudPartnerAllData = CrudStore.get(
      CrudStoreItem.PartnerAllData,
      'connector-PartnerAllData-delete'
    )
    const crudLegal = CrudStore.get(CrudStoreItem.LegalPartnerRequests)
    const crudOpened = CrudStore.get(CrudStoreItem.OpenedPartnerRequests)
    const legalItem = crudLegal.getDataFromStore().find((el) => el.LegalEntryIdExt === item.EntryId)
    const openedItem = crudOpened.getDataFromStore().find((el) => el.EntryIdExt === item.EntryId)

    switch (formId) {
      case `406`:
        if (item.EntryId) {
          mergeLegalAndOpened({}, legalItem, openedItem, PartnerExtFields)
          if (openedItem) {
            crudOpened.removeQueries()
          }

          oldItem = await crudPartnerAllData.getById({
            id: item.EntryId,
            keyField: 'EntryIdExt',
          })
          if (oldItem) {
            for (const field in PartnerExtFields) {
              oldItem[field] = undefined
            }
            resultItem = oldItem
          }
        }

        return resultItem ? [resultItem] : resultItem
      case `458`:
        if (item.EntryId) {
          mergeLegalAndOpened({}, legalItem, openedItem, AddExtFields)
          oldItem = await crudPartnerAllData.getById({
            id: item.EntryId,
            keyField: 'EntryIdAdd',
          })
          if (oldItem) {
            for (const field in AddExtFields) {
              oldItem[field] = undefined
            }
            resultItem = oldItem
          }
        }

        return resultItem ? [resultItem] : resultItem
      case `502`:
        if (item.EntryId) {
          mergeLegalAndOpened({}, legalItem, openedItem, LegalExtFields)
          if (legalItem) {
            crudLegal.removeQueries()
          }

          oldItem = await crudPartnerAllData.getById({
            id: item.EntryId,
            keyField: 'LegalEntryIdExt',
          })
          if (oldItem) {
            for (const field in LegalExtFields) {
              oldItem[field] = undefined
            }
            resultItem = oldItem
          }
        }
        return resultItem ? [resultItem] : resultItem
    }
    return resultItem
  }

  public static createContactCodeRequests = async (
    formId: string,
    items: IForm[]
  ): Promise<IForm[]> => {
    let resultArr: IFormPartners[] = []
    const crud = CrudStore.get(
      CrudStoreItem.ContactCodeRequests,
      'connector-ContactCodeRequests-create'
    )
    switch (formId) {
      case `514`:
        resultArr = [...items] as IFormPartners[]
        crud.removeQueries()
    }
    return resultArr
  }

  public static createData = async (
    formId: string,
    items: IForm[],
    crudStoreItem: CrudStoreItem
  ): Promise<IForm[]> => {
    CrudStore.get(crudStoreItem).removeQueries()
    return items
  }

  public static updateContactAllData = async (
    formId: string,
    items: IForm[],
    isCreate: boolean = false
  ): Promise<IForm[]> => {
    const resultArr: IForm[] = []
    if (!items[0]) {
      return resultArr
    }
    const item = items[0]
    const crudOpened = CrudStore.get(CrudStoreItem.OpenedContactRequests)

    if (!item.ContactID) {
      return resultArr
    }

    const openedItem = crudOpened.getDataFromStore().find((el) => el.ContactID === item.ContactID)

    switch (formId) {
      case `375`:
        await mergeUpdate(
          resultArr,
          item,
          ContactExtFields,
          CrudStoreItem.ContactAllData,
          'ContactID'
        )
        mergeLegalAndOpened(item, undefined, openedItem, ContactExtFields)
        break
      case `379`:
        await mergeUpdate(
          resultArr,
          item,
          AddContactExtFields,
          CrudStoreItem.ContactAllData,
          'ContactID'
        )
        mergeLegalAndOpened(item, undefined, openedItem, AddContactExtFields)
        break
    }
    if (isCreate) {
      CrudStore.get(CrudStoreItem.ContactAllData).removeQueries()
      CrudStore.get(CrudStoreItem.OpenedContactRequests).removeQueries()
    }
    return resultArr
  }

  public static deleteContactAllData = async (
    formId: string,
    item: IForm
  ): Promise<IFormProfile[] | null> => {
    let resultItem: IForm | null = null
    let oldItem: IForm | null = null
    const crud = CrudStore.get(CrudStoreItem.ContactAllData)
    const crudOpened = CrudStore.get(CrudStoreItem.OpenedContactRequests)

    const openedItem = crudOpened.getDataFromStore().find((el) => el.ContactID === item.ContactID)

    switch (formId) {
      case `375`:
        if (item.EntryId) {
          mergeLegalAndOpened({}, undefined, openedItem, ContactExtFields)
          oldItem = await crud.getById({ id: item.EntryId, keyField: 'EntryIdExt' })
          if (oldItem) {
            for (const field in ContactExtFields) {
              oldItem[field] = undefined
            }
            resultItem = oldItem
          }
        }

        return resultItem ? [resultItem] : resultItem
      case `379`:
        if (item.EntryId) {
          mergeLegalAndOpened({}, undefined, openedItem, AddContactExtFields)
          oldItem = await crud.getById({ id: item.EntryId, keyField: 'EntryIdAdd' })
          if (oldItem) {
            for (const field in AddContactExtFields) {
              oldItem[field] = undefined
            }
            resultItem = oldItem
          }
        }

        return resultItem ? [resultItem] : resultItem
    }
    return resultItem
  }

  public static createCodesDictionary = async (
    formId: string,
    items: IForm[]
  ): Promise<IForm[]> => {
    const resultArr: IForm[] = []
    switch (formId) {
      case `515`:
        CrudStore.get(CrudStoreItem.CodesDictionary).removeQueries()
        return items
    }
    return resultArr
  }
}
